import styled from 'styled-components';
import { ThemeColours } from '../../../../../styles/ThemeColours';
import { FontSize, FontWeight, FONT_STACK, LineHeight } from '../../../../../styles/constants';
import { buildHeImgixUrl } from '../../../../images/imgix';

export const Container = styled.div`
  align-items: center;
  border-radius: 100px;
  cursor: pointer;
  display: flex;
  flex-flow: row nowrap;
  height: 40px;

  &:hover {
    background-color: ${ThemeColours.mono100};
  }
`;

export const LogoContainer = styled.div`
  flex: 0 0 24px;
  height: 24px;
  margin: 0 12px;
`;

export const Name = styled.span`
  ${FONT_STACK}
  color: ${ThemeColours.mono800};
  display: inline-block;
  font-size: ${FontSize.SMALL};
  font-weight: ${FontWeight.SEMI_BOLD};
  line-height: ${LineHeight.EXTRA_SMALL};
  margin-right: 12px;
`;

const makeSpecialtyIconUrl = (path: string) => buildHeImgixUrl(path, { w: 48, h: 48 });

export const PromotionIcon = styled.span<{ path: string }>`
  background-color: ${ThemeColours.primary300};
  background-image: url(${props => makeSpecialtyIconUrl(props.path)});
  background-position: center;
  background-repeat: no-repeat;
  background-size: auto 14.4px;
  border-radius: 100px;
  display: inline-block;
  height: 24px;
  padding: 8px;
  width: 24px;
`;
